import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="mt-24 bg-[#4A0E17] text-[#FAF6F0] pt-16 pb-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 font-devanagari text-[400px] leading-none text-[#D4AF37]">ॐ</div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-full bg-[#D4AF37] text-[#4A0E17] flex items-center justify-center font-devanagari text-2xl">ॐ</span>
              <span className="font-serif text-2xl text-[#F3E5AB]">Pancham Dham</span>
            </div>
            <p className="text-sm text-[#FAF6F0]/70 leading-relaxed">
              A sacred devotional portal preserving the 1008 Names of Lord Shiva and offering pilgrimage to Pancham Dham, Cambodia.
            </p>
          </div>
          <div>
            <div className="overline text-[#D4AF37] mb-3">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/names" className="hover:text-[#D4AF37] transition-sacred">1008 Names</Link></li>
              <li><Link to="/daily-verse" className="hover:text-[#D4AF37] transition-sacred">Daily Verse</Link></li>
              <li><Link to="/pilgrimage" className="hover:text-[#D4AF37] transition-sacred">Cambodia Yatra</Link></li>
              <li><Link to="/donate" className="hover:text-[#D4AF37] transition-sacred">Seva & Donations</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#D4AF37] mb-3">Devotee</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/register" className="hover:text-[#D4AF37] transition-sacred">Create Account</Link></li>
              <li><Link to="/login" className="hover:text-[#D4AF37] transition-sacred">Sign In</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#D4AF37] transition-sacred">My Bookmarks</Link></li>
              <li><Link to="/newsletter" className="hover:text-[#D4AF37] transition-sacred">Newsletter</Link></li>
              <li><Link to="/transparency" className="hover:text-[#D4AF37] transition-sacred">Fees & Transparency</Link></li>
              <li><Link to="/become-supplier" className="hover:text-[#D4AF37] transition-sacred">Sell on Pancham Dham</Link></li>
              <li><Link to="/advertise" className="hover:text-[#D4AF37] transition-sacred">Advertise With Us</Link></li>
              <li><Link to="/satsangs" className="hover:text-[#D4AF37] transition-sacred">Live Satsangs</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#D4AF37] mb-3">Daily Blessing</div>
            <p className="text-sm text-[#FAF6F0]/70 mb-3">Receive a sacred verse in your inbox each sunrise.</p>
            <Link to="/newsletter" data-testid="footer-subscribe-cta" className="inline-flex btn-ghost-gold text-sm !text-[#D4AF37] !border-[#D4AF37] hover:!bg-[#D4AF37]/10">Subscribe →</Link>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#D4AF37]/20 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FAF6F0]/50">
          <div>© {new Date().getFullYear()} Pancham Dham. ॐ नमः शिवाय</div>
          <div className="font-mono">Siem Reap · Cambodia</div>
        </div>
      </div>
    </footer>
  );
}
